import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetServerSideProps, NextPage } from 'next';

import { LibrariansContent } from '@/components/ui/features/librarians-resource/LibrariansContent/LibrariansContent';
import { LibrariansResourceHeader } from '@/components/ui/features/librarians-resource/LibrariansResourceHeader/LibrariansResourceHeader';
import { LibrariansResourceSeo } from '@/components/ui/features/librarians-resource/LibrariansResourceSeo/LibrariansResourceSeo';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { librarianResourcesQueryOptions } from '@/queries/upgrade/librarianResources';

const LibrariansResourcePage: NextPage = () => {
  return (
    <Layout navigationVariant="default">
      <LibrariansResourceSeo />
      <LibrariansResourceHeader />
      <LibrariansContent />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const queryClient = new QueryClient();

  try {
    await queryClient.prefetchQuery(librarianResourcesQueryOptions());
  } catch (err) {
    return { notFound: true };
  }

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};

export default LibrariansResourcePage;
